import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-x-circle-fill",
  templateUrl: "./med-icon-x-circle-fill.component.html",
})
export class MedIconXCircleFillComponent extends SvgMixinComponent {}
